export const environment = {
  production: true,
  apiUrl: 'https://api.dev.edg-pro.com',
  frontUrl: 'https://dev.edg-pro.com',
  portalUrl: 'https://dev.edg-pro.com',
  domain: 'dev.edg-pro.com',
  tokenName: 'token.dev.edg-pro.com',
  sentry: {
    dsn: 'https://20805b0e29824dd98f2464b8b3e3aa77@o4504261033000960.ingest.sentry.io/4504261035163648',
    env: 'development',
  },
  binaries: {
    installer: 'https://cdn.dev.edg-pro.com/binaries/Installer.zip',
    moduleBuilder: 'https://cdn.dev.edg-pro.com/binaries/ModuleBuilder.zip',
  },
  contact: 'eduardbcomabsoft@gmail.com',
};
